// ---------------------------------------------------------------------------
// Quodin platform pages.
//
// One frontend plugin holding the UIs for the backend plugins registered in
// packages/backend: Crossplane, Argo CD, Argo Workflows, n8n, Langflow/Langfuse
// and the LLM cost view, plus the embedded Grafana page.
//
// Each page is lazily loaded so the initial bundle stays small — none of this
// is needed to render the home page.
// ---------------------------------------------------------------------------
import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import LayersIcon from '@material-ui/icons/Layers';

const page = (name: string, path: string, load: () => Promise<JSX.Element>) =>
  PageBlueprint.make({ name, params: { path, loader: load } });

const crossplanePage = page('crossplane', '/crossplane', async () => {
  const { CrossplanePage } = await import('./CrossplanePage');
  return <CrossplanePage />;
});

const gitopsPage = page('gitops', '/gitops', async () => {
  const { GitOpsPage } = await import('./GitOpsPage');
  return <GitOpsPage />;
});

const workflowsPage = page('pipelines', '/pipelines', async () => {
  const { WorkflowsPage } = await import('./WorkflowsPage');
  return <WorkflowsPage />;
});

const automationPage = page('automation', '/automation', async () => {
  const { AutomationPage } = await import('./AutomationPage');
  return <AutomationPage />;
});

const srePage = page('sre', '/sre', async () => {
  const { SrePage } = await import('./SrePage');
  return <SrePage />;
});

const llmOpsPage = page('llmops', '/llmops', async () => {
  const { LlmOpsPage } = await import('./LlmOpsPage');
  return <LlmOpsPage />;
});

const observabilityPage = page('observability', '/observability', async () => {
  const { ObservabilityPage } = await import('./ObservabilityPage');
  return <ObservabilityPage />;
});

const finopsPage = page('finops', '/finops', async () => {
  const { FinOpsPage } = await import('./FinOpsPage');
  return <FinOpsPage />;
});

const memoryPage = page('memory', '/memory', async () => {
  const { MemoryPage } = await import('./MemoryPage');
  return <MemoryPage />;
});

export const platformPlugin = createFrontendPlugin({
  pluginId: 'quodin-platform',
  title: 'Platform',
  icon: <LayersIcon />,
  extensions: [
    crossplanePage,
    gitopsPage,
    workflowsPage,
    automationPage,
    srePage,
    llmOpsPage,
    observabilityPage,
    finopsPage,
    memoryPage,
  ],
});
